var _defs, _ellipse, _ellipse2, _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4, _path5, _ellipse3, _ellipse4, _circle5, _circle6, _circle7, _circle8, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHolistic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #404040;\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 1px;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #252525;\n      }\n\n      .cls-3 {\n        fill: #252525;\n        fill-rule: evenodd;\n      }\n    "))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 10,
    cy: 12.5,
    rx: 3.031,
    ry: 3.031
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1_copy",
    "data-name": "Ellipse 1 copy",
    className: "cls-2",
    cx: 10,
    cy: 3.422,
    rx: 2.031,
    ry: 2.016
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_2",
    "data-name": "Ellipse 1 copy 2",
    className: "cls-2",
    cx: 2.922,
    cy: 9.484,
    r: 2.016
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_3",
    "data-name": "Ellipse 1 copy 3",
    className: "cls-2",
    cx: 4.953,
    cy: 19.578,
    r: 2.016
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_4",
    "data-name": "Ellipse 1 copy 4",
    className: "cls-2",
    cx: 16.063,
    cy: 19.578,
    r: 2.031
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_5",
    "data-name": "Ellipse 1 copy 5",
    className: "cls-2",
    cx: 17.078,
    cy: 9.484,
    r: 2.016
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4.79,10.969l0.319-.958,3.03,1.01-0.319.958Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_copy",
    "data-name": "Shape 1 copy",
    className: "cls-3",
    d: "M10,5.44h1.01V9.48H10V5.44Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_copy_2",
    "data-name": "Shape 1 copy 2",
    className: "cls-3",
    d: "M15.05,10.118L15.552,11,12.045,13,12,12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_copy_3",
    "data-name": "Shape 1 copy 3",
    className: "cls-3",
    d: "M15.214,17.827l0.68-.793-3.037-2.766-0.68.793Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_copy_4",
    "data-name": "Shape 1 copy 4",
    className: "cls-3",
    d: "M5.7,18.587L4.958,17.68l3.294-3.161,0.738,0.907Z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 10,
    cy: 12.5,
    rx: 3.031,
    ry: 3.031
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1_copy-2",
    "data-name": "Ellipse 1 copy",
    className: "cls-2",
    cx: 10,
    cy: 3.422,
    rx: 2.031,
    ry: 2.016
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_2-2",
    "data-name": "Ellipse 1 copy 2",
    className: "cls-2",
    cx: 2.922,
    cy: 9.484,
    r: 2.016
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_3-2",
    "data-name": "Ellipse 1 copy 3",
    className: "cls-2",
    cx: 4.953,
    cy: 19.578,
    r: 2.016
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_4-2",
    "data-name": "Ellipse 1 copy 4",
    className: "cls-2",
    cx: 16.063,
    cy: 19.578,
    r: 2.031
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_5-2",
    "data-name": "Ellipse 1 copy 5",
    className: "cls-2",
    cx: 17.078,
    cy: 9.484,
    r: 2.016
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4.79,10.969l0.319-.958,3.03,1.01-0.319.958Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_copy-2",
    "data-name": "Shape 1 copy",
    className: "cls-3",
    d: "M10,5.44h1.01V9.48H10V5.44Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_copy_2-2",
    "data-name": "Shape 1 copy 2",
    className: "cls-3",
    d: "M15.05,10.118L15.552,11,12.045,13,12,12Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_copy_3-2",
    "data-name": "Shape 1 copy 3",
    className: "cls-3",
    d: "M15.214,17.827l0.68-.793-3.037-2.766-0.68.793Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_copy_4-2",
    "data-name": "Shape 1 copy 4",
    className: "cls-3",
    d: "M5.7,18.587L4.958,17.68l3.294-3.161,0.738,0.907Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolistic);
export default __webpack_public_path__ + "static/media/holistic.92f7a5936d3965f4163d623a0c7b4128.svg";
export { ForwardRef as ReactComponent };